<template>
  <div>
    <v-container class="pa-4 pa-sm-8" fluid>
      <v-row class="mt-3 mt-sm-0">
        <h2 class="dark--text text-h5 font-weight-bold ms-3">API Users</h2>
        <!-- <v-spacer></v-spacer> -->
        <v-layout justify-end class="me-3">
          <CreateAPIUser></CreateAPIUser>
        </v-layout>
      </v-row>

      <!-- <v-system-bar height="1" class="mt-2"></v-system-bar> -->
      <!-- {{ menuList }} -->
      <v-data-table
        :mobile-breakpoint="0"
        :headers="headers"
        :items="itemsWithSno"
        class="elevation-1 mt-10"
        :loading="loading"
        :server-items-length="totalItemsCount"
        :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }"
      >
        <template v-slot:item.actions="{ item }">
          <v-row>
            <!-- {{ item }} -->

            <DeleteAPIUser :method="item" />
          </v-row>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import CreateAPIUser from "../components/CreateAPIUser.vue";
import DeleteAPIUser from "../components/DeleteAPIUser";

export default {
  components: {
    CreateAPIUser,
    DeleteAPIUser,
  },
  mounted() {
    this.$root.$on("getAllAPIUsers", () => {
      this.loading = true;
      this.$apollo.queries.getAllAPIUsers.refetch({});
    });
  },
  data() {
    return {
      loading: false,
      totalItemsCount: 25,
      users: [],
      headers: [
        {
          text: "#",
          sortable: false,
          value: "slNo",
          width: 120,
        },
        { text: "Name", value: "firstnameEn", width: 230 },
        { text: "API Key", value: "username", width: 230 },
        { text: "Action", value: "actions", sortable: false, width: 90 },
      ],
    };
  },
  apollo: {
    getAllAPIUsers() {
      return {
        query: require("../api/getAllAPIUsers.graphql"),
        result({ data, loading }) {
          this.users = data.getAllAPIUsers.users;
          this.loading = loading;
        },
      };
    },
  },
  computed: {
    itemsWithSno() {
      return this.users.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
};
</script>
